import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-card-form',
  standalone: true,
  imports: [MatSidenavModule],
  template: `
    <div class="container-fluid full-height">
      <div class="row align-items-start justify-content-start">
        <div class="col-12">
          <div class="white_card card_height_100 mb_30">
            <div class="white_card_header">
              <div class="row align-items-center">
                <!-- HEADER TITLE -->
                <div class="col-auto d-none d-md-flex">
                  <ng-content select="[card-title]"></ng-content>
                </div>
                <!-- BUTTONS -->
                <div class="col d-none d-md-block text-end">
                  <ng-content select="[card-actions]"></ng-content>
                </div>
                <!-- ADD BTN SMALL DEVICE-->
                <div class="col d-block d-md-none text-end">
                  <ng-content select="[card-sm-actions]"></ng-content>
                </div>
              </div>
            </div>

            <div class="white_card_content">
              <ng-content select="[card-form-content]"></ng-content>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./card-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardFormComponent {}
